// extracted by mini-css-extract-plugin
export default {"channel-stats":"styles_channel-stats__hPGMy","channel-stats__number":"styles_channel-stats__number__ujitG"};